import { Avatar, Button, Box, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Switch, Tabs, Tab, Table, TableContainer, TableHead, TableRow, TableCell, TableBody, TextField, Typography, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useEffect, useState, useRef, useCallback } from "react";
import { toast } from "react-toastify";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import { green } from "@material-ui/core/colors";
import FormatDate from "../../helpers/FormatDate";
import TabPanel from "../TabPanel";
import classNames from "classnames";
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';
import { useHistory } from "react-router-dom";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import ConfirmationModal from "../ConfirmationModal";

const useStyles = makeStyles(theme => ({
	btnWrapper: {
		position: "relative",
	},
	buttonProgress: {
		color: green[500],
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -12,
		marginLeft: -12,
	},
	groupTitle: {
		fontSize: "1.3rem",
		fontWeight: "600",
		color: "#616161"
	},
	groupSubtitle: {
		"& h6": {
			fontSize: "1rem",
			color: "#9e9e9e"
		}
	},
	infoTitle: {
		display: "block",
		fontSize: "1.1rem",
		marginRight: "10px",
		width: "100%",
		marginBottom: "5px"
	},
	infoText: {
		fontSize: "1rem"
	},
	profileImage: {
		display: "inline-flex",
		width: "100%",
		height: "80px",
		boxShadow: "0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3)"
	},
	tab: {
		margin: "0",
		height: "300px",
		overflowY: "auto",
		padding: "15px 10px 10px 10px"
	},
	disabled: {
		cursor: "not-allowed",
		"& input": {
			cursor: "not-allowed"
		},
		"& textarea": {
			cursor: "not-allowed"
		},
		"& span": {
			cursor: "not-allowed"
		}
	},
	editPicture: {
		position: "absolute",
		top: "65px",
		right: "0",
		width: "25px",
		height: "25px",
		boxShadow: "0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3)",
	},
	removedUser: {
		textDecoration: "line-through"
	},
	close: {
		position: "absolute",
		right: "20px",
		top: "20px",
	}
}));

const GroupInformationModal = ({ open, onClose, connectionId, queueId, contactId, numberConnection, isCreate = false }) => {
	const [loading, setLoading] = useState(false);
	const classes = useStyles();
	const groupInitialInformation = {
		subject: "",
		desc: "",
		restrict: false,
		announce: false,
		joinApprovalMode: false,
		memberAddMode: false
	}
	const [groupInformation, setGroupInformation] = useState(groupInitialInformation);
	const [tab, setTab] = useState(0);
	const tabs = ["Informações Gerais", "Participantes"];
	const fileInputRef = useRef(null);
	const [files, setFiles] = useState([]);
	const [removeUsers, setRemoveUsers] = useState([]);
	const [addUsers, setAddUsers] = useState([]);
	const [number, setNumber] = useState(''); // texto que o usuário digita
	const [selectedContact, setSelectedContact] = useState(null); // contato selecionado (ou null)
	const history = useHistory();
	const [contacts, setContacts] = useState([]);
	const [leaveGroup, setLeaveGroup] = useState(false);

	const handleSave = async () => {
		if (!groupInformation?.subject || String(groupInformation.subject).trim() == "") {
			toastError({ response: { data: { error: "Insira o nome do Grupo" } } });
			return;
		}
		try {
			setLoading(true);
			const formData = new FormData();
			formData.append("connectionId", connectionId);
			formData.append("queueId", queueId);
			formData.append("contactId", contactId);
			formData.append("subject", groupInformation.subject);
			if (groupInformation?.desc) formData.append("desc", groupInformation?.desc);
			formData.append("restrict", groupInformation?.restrict == true ? true : false);
			formData.append("announce", groupInformation?.announce == true ? true : false);
			formData.append("joinApprovalMode", groupInformation?.joinApprovalMode == true ? true : false);
			formData.append("memberAddMode", groupInformation?.memberAddMode == true ? true : false);
			formData.append("removeUsers", JSON.stringify(removeUsers));
			formData.append("addUsers", JSON.stringify(addUsers));

			if (files.length == 1) formData.append("medias", files[0]);

			const { data } = await api.post(isCreate == true ? `group/create` : `group/setInformation`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
			toast.success("Atualizado com sucesso.");
			handleClose();
			if (isCreate == true && data?.uuid) history.push(`/tickets/${data.uuid}`);
		} catch (err) {
			console.error({ err });
			toastError(err);
		} finally {
			setLoading(false);
		}
	}

	const handleLeave = async () => {
		try {
			await api.post(`group/leave`, { connectionId, contactId });
			toast.success("Atualizado com Sucesso.");
			handleClose();
		} catch (err) {
			console.error({ err });
			toastError(err);
		} finally {
			setLoading(false);
		}
	}

	const handleClose = (event, reason) => {
		if (reason == 'backdropClick') return;
		
		if (onClose) onClose(event);
		setGroupInformation(groupInitialInformation);
		setFiles([]);
		setRemoveUsers([]);
		setAddUsers([]);
		setNumber("");
		setContacts([]);
		setTab(0);
	}

	const handleTab = (event, newValue) => {
		setTab(newValue);
	};

	const handleButtonClick = () => {
		if (fileInputRef.current) {
			fileInputRef.current.click();
		}
	};

	useEffect(() => {
		if (open != true || !connectionId || !contactId) return;

		let isMounted = true;
		const abortController = new AbortController();
		setLoading(true);

		(async () => {
			try {
				const { data } = await api.post(`group/getInformation`, {
					connectionId,
					contactId
				}, {
					signal: abortController.signal,
				});
				if (!isMounted) return;
				if (data) setGroupInformation(data);

				const { data: contactData } = await api.get(`contacts/byConnectionId/${connectionId}`);
				if (Array.isArray(contactData?.contacts) && contactData.contacts.length > 0) {
					setContacts(contactData.contacts.filter((c) => c?.isGroup != true).map((c) => { return { id: c.id, name: c.name, number: c.number } }));
				}

			} catch (err) {
				if (!isMounted || err.name == 'AbortError') return;
				console.error({ err });
				toastError(err);
			} finally {
				setLoading(false);
			}
		})();

		return () => {
			isMounted = false;
			abortController.abort();
		};

	}, [open]);

	const handleRemoveUser = (id) => {
		setRemoveUsers(prev => {
			if (prev.includes(id) == false) return [...prev, id];
			else return prev.filter(p => p != id);
		});
	}

	const handleCancelUser = (id) => {
		setAddUsers(prev => { return prev.filter(p => p != id); });
		setGroupInformation(prev => {
			return {
				...prev,
				participants: [...prev.participants].filter(p => p.id != id)
			}
		});
	}

	return (
		<>
			<Dialog
				open={open == true ? true : false}
				onClose={handleClose}
				aria-labelledby="ModalTransfer"
				size="sm"
				fullWidth
			>
				<DialogTitle style={{ marginTop: '10px' }}>
					<Box>
						<Typography variant="h5" className={classes.groupTitle}>{groupInformation?.contactName || i18n.t("groupInformation.storeTitle")}</Typography>
						<Box
							className={classes.groupSubtitle}
						>
							<Typography 
								variant="h6"
								style={{
									display: "inline-block",
									marginRight: "10px"
								}}
							>
								{i18n.t("groupInformation.title")}
							</Typography>
						</Box>
						<Tooltip
							title={
								<Typography component="label">Fechar</Typography>
							}
						>
							<IconButton
								aria-label="close"
								size="small"
								className={classes.close}
								disabled={loading}
								onClick={() => handleClose()}
							>
								<CloseOutlinedIcon />
							</IconButton>
						</Tooltip>
					</Box>
				</DialogTitle>
				<DialogContent style={{ position: "relative" }}>
					<>
						<Tabs
							value={tab}
							onChange={handleTab}
							aria-label="tabs of group contact information"
						>
							{tabs.map((t, idx) => {
								return (
									<Tab
										label={t}
										id={`groupInformation-${contactId}-${idx}`}
										ariaControls={`tabpanel-${contactId}-${idx}`}
									/>
								)
							})}
						</Tabs>
						<Button
							aria-label="signout"
							color="secondary"
							disabled={loading}
							onClick={() => setLeaveGroup(true)}
							size="small"
							style={{
								fontSize: ".85rem",
								textTransform: "none",
								position: "absolute",
								top: "17px",
								right: "30px"
							}}
						>
							Sair do Grupo
						</Button>
						<TabPanel
							value={tab}
							name={0}
							className={classes.tab}
						>
							<Grid container style={{ marginBottom: "10px" }} spacing={1}>
								<Grid item xs={2} style={{ position: "relative" }}>
									<Avatar
										className={classes.profileImage}
										src={files.length == 1 ? URL.createObjectURL(files[0]) : groupInformation?.profilePictureUrl}
										alt="contact_image"
									/>
									{
										(groupInformation?.canUpdateInformations == true || isCreate == true) &&
										<Tooltip
											title={
												<Typography component="label">Editar Foto</Typography>
											}
										>
											<IconButton
												aria-label="edit"
												className={classes.editPicture}
												onClick={handleButtonClick}
												style={{
													backgroundColor: "#ffffff"
												}}
											>
												<EditOutlinedIcon />
												<input
													type="file"
													ref={fileInputRef}
													style={{ display: 'none' }}
													accept={".jpg,.png"}
													onChange={(e) => {
														if (e?.target?.files[0]) setFiles(e.target.files);
													}}
												/>
											</IconButton>
										</Tooltip>
									}
								</Grid>
								<Grid item xs={10}>
									<Grid container>
										<Grid item xs={12}>
											<Typography variant="h6" className={classes.infoTitle}>Nome no Whatsapp:</Typography>
											<TextField
												id="informationGroupName"
												variant="outlined"
												placeholder="Nome no Whatsapp"
												size="small"
												fullWidth
												value={groupInformation.subject}
												onChange={(e) => {
													const value = e.currentTarget?.value;
													if (value) {
														setGroupInformation(prev => ({ ...prev, subject: value }));
													}
												}}
												disabled={groupInformation?.canUpdateInformations != true && isCreate == false}
												inputProps={{ maxLength: 100 }}
												required
												className={classNames({
													[classes.disabled]: groupInformation?.canUpdateInformations != true && isCreate == false,
												})}
											/>
										</Grid>
									</Grid>

									<Grid container>
										<Grid item xs={12}>
											<Typography variant="h6" className={classes.infoTitle}>Descrição:</Typography>
											<TextField
												id="informationGroupDescription"
												variant="outlined"
												placeholder="Descrição"
												size="small"
												fullWidth
												multiline
												inputProps={{
													rows: 5,
													maxLength: 255
												}}
												value={groupInformation.desc}
												onChange={(e) => {
													const value = e.currentTarget?.value;
													if (value) {
														setGroupInformation(prev => ({ ...prev, desc: value }));
													}
												}}
												disabled={groupInformation?.canUpdateInformations != true && isCreate == false}
												className={classNames({
													[classes.disabled]: groupInformation?.canUpdateInformations != true && isCreate == false,
												})}
											/>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
							<Grid container style={{ marginBottom: "10px", display: isCreate == true ? "none" : "" }}>
								<Grid item xs={12}>
									<Typography variant="h6" className={classes.infoTitle}>Data da Ultima Atualização:</Typography>
									<TextField
										id="informationGroupUpdatedName"
										variant="outlined"
										placeholder="Data de Atualização do Nome"
										size="small"
										fullWidth
										value={groupInformation?.subjectTime ? FormatDate(new Date(groupInformation.subjectTime * 1000), true, 1) : "-"}
										disabled={true}
										className={classes.disabled}
									/>
								</Grid>
							</Grid>
							<Grid container style={{ marginBottom: "10px", display: isCreate == true ? "none" : "" }}>
								<Grid item xs={12}>
									<Typography variant="h6" className={classes.infoTitle}>Data de Criação:</Typography>
									<TextField
										id="informationGroupCreatedAt"
										variant="outlined"
										placeholder="Data de Criação"
										size="small"
										fullWidth
										value={groupInformation?.creation ? FormatDate(new Date(groupInformation.creation * 1000), true, 1) : "-"}
										disabled={true}
										className={classes.disabled}
									/>
								</Grid>
							</Grid>
							<Grid container style={{ marginBottom: "10px", display: isCreate == true ? "none" : "" }}>
								<Grid item xs={12}>
									<Typography variant="h6" className={classes.infoTitle}>Link de Convite:</Typography>
									<TextField
										id="informationGroupInviteLink"
										variant="outlined"
										placeholder="Link de Convite"
										size="small"
										fullWidth
										value={groupInformation?.inviteLink && groupInformation?.inviteLink != "" ? groupInformation.inviteLink : "-"}
										disabled={true}
									/>
								</Grid>
							</Grid>
							<Grid container style={{ marginBottom: "10px" }}>
								<Grid item xs={12}>
									<TableContainer
										style={{ height: "250px" }}
									>
										<Table
											size="medium"
											stickyHeader
											aria-label="enhanced table"
											aria-labelledby="tableTitle"
										>
											<TableHead>
												<TableRow>
													<TableCell
														align="left"
													>
														Configuração
													</TableCell>
													<TableCell
														align="left"
													>
														Status
													</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												<TableRow>
													<TableCell align="left">
														<Typography variant="h6" className={classes.infoTitle}>Apenas administradores alteram as configurações do grupo?</Typography>
													</TableCell>
													<TableCell align="left">
														<Switch
															checked={groupInformation?.restrict == true ? true : false}
															onChange={() => {
																setGroupInformation(prev => { return ({ ...prev, restrict: prev?.restrict == true ? false : true }) })
															}}
															color="primary"
															name={`changeRestrict`}
															// disabled={groupInformation?.canUpdateInformations != true}
															disabled={true}
															className={classes.disabled}
														/>
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell align="left">
														<Typography variant="h6" className={classes.infoTitle}>Apenas administradores escrevem mensagens?</Typography>
													</TableCell>
													<TableCell align="left">
														<Switch
															checked={groupInformation?.announce == true ? true : false}
															onChange={() => {
																setGroupInformation(prev => { return ({ ...prev, announce: prev?.announce == true ? false : true }) })
															}}
															color="primary"
															name={`changeAnnounce`}
															// disabled={groupInformation?.canUpdateInformations != true}
															disabled={true}
															className={classes.disabled}
														/>
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell align="left">
														<Typography variant="h6" className={classes.infoTitle}>Solicitar aprovação para ingressar no grupo?</Typography>
													</TableCell>
													<TableCell align="left">
														<Switch
															checked={groupInformation?.joinApprovalMode == true ? true : false}
															onChange={() => {
																setGroupInformation(prev => { return ({ ...prev, joinApprovalMode: prev?.joinApprovalMode == true ? false : true }) })
															}}
															color="primary"
															name={`changeJoinApprovalMode`}
															// disabled={groupInformation?.canUpdateInformations != true}
															disabled={true}
															className={classes.disabled}
														/>
													</TableCell>
												</TableRow>
												<TableRow>
													<TableCell align="left">
														<Typography variant="h6" className={classes.infoTitle}>Membros adicionam participantes?</Typography>
													</TableCell>
													<TableCell align="left">
														<Switch
															checked={groupInformation?.memberAddMode == true ? true : false}
															onChange={() => {
																setGroupInformation(prev => { return ({ ...prev, memberAddMode: prev?.memberAddMode == true ? false : true }) })
															}}
															color="primary"
															name={`changeMemberAddMode`}
															// disabled={groupInformation?.canUpdateInformations != true}
															disabled={true}
															className={classes.disabled}
														/>
													</TableCell>
												</TableRow>
											</TableBody>
										</Table>
									</TableContainer>
								</Grid>
							</Grid>
						</TabPanel>
						<TabPanel
							value={tab}
							name={1}
							className={classes.tab}
						>
							<Grid
								container
								spacing={1}
								style={{ marginBottom: "20px", position: "relative" }}
							>
								<Grid item xs={10}>
									<Typography variant="h6" className={classes.infoTitle}>
										Número do Contato:
									</Typography>
									<Autocomplete
										freeSolo
										options={contacts}
										getOptionLabel={(option) => option?.name != option?.number ? `${option.name} - ${option.number}` : option.number}
										value={selectedContact}
										inputValue={number}
										disabled={connectionId && contactId && groupInformation?.canInsertParticipants != true}
										className={classNames({
											[classes.disabled]: connectionId && contactId && groupInformation?.canInsertParticipants != true,
										})}
										onInputChange={(event, newInputValue) => {
											setNumber(newInputValue); // controla texto digitado
										}}
										onChange={(event, newValue) => {
											if (typeof newValue === 'string') {
												// Digitou manualmente: mantemos o texto digitado (esperando que seja número ou algo próximo)
												setNumber(newValue);
												setSelectedContact(null);
											} else if (newValue && typeof newValue === 'object') {
												// Selecionou um contato: salvamos apenas o número puro
												setNumber(newValue.number);
												setSelectedContact(newValue);
											} else {
												setNumber('');
												setSelectedContact(null);
											}
										}}
										renderInput={(params) => (
											<TextField
												{...params}
												id="informationGroupParticipantName"
												variant="outlined"
												placeholder="Cod. País + Cod. Estado + número"
												size="small"
												fullWidth
												inputProps={{
													...params.inputProps,
													maxLength: 50,
												}}
												required
												disabled={groupInformation?.canInsertParticipants != true}
											/>
										)}
									/>
								</Grid>
								<Grid item xs={2} style={{ position: "relative" }}>
									<Button
										color="primary"
										variant="contained"
										style={{
											position: "absolute",
											bottom: "6px",
											width: "100%",
											height: "40px",
										}}
										disabled={connectionId && contactId && groupInformation?.canInsertParticipants != true}
										className={classNames({
											[classes.disabled]: connectionId && contactId && groupInformation?.canInsertParticipants != true,
										})}
										onClick={() => {

											if (connectionId && contactId && groupInformation?.canInsertParticipants != true) return;

											// separar nome pelo separador "-"
											const splitted = number.split("-");

											// remove caracteres não numéricos para garantir
											const formattedNumber = splitted[splitted.length - 1].replace(/\D/g, "");
											const jid = `${formattedNumber}@s.whatsapp.net`;

											if (formattedNumber && !addUsers.includes(jid)) {
												setAddUsers((prev) => [...prev, jid]);
												setGroupInformation((prev) => ({
													...prev,
													participants: Array.isArray(prev.participants) && prev.participants.length > 0
														? [...prev.participants, {
															id: jid,
															name: formattedNumber,
															number: formattedNumber,
															profilePictureUrl: "",
														}]
														: [{
															id: jid,
															name: formattedNumber,
															number: formattedNumber,
															profilePictureUrl: "",
														}],
												}));
												setNumber('');            // limpa texto digitado
												setSelectedContact(null); // limpa seleção
											}
										}}
									>
										adicionar
									</Button>

								</Grid>
							</Grid>

							<Grid container style={{ marginBottom: "10px" }}>
								<Grid item xs={12}>
									<TableContainer
										style={{ height: "175px" }}
									>
										<Table
											size="medium"
											stickyHeader
											aria-label="enhanced table"
											aria-labelledby="tableTitle"
										>
											<TableHead>
												<TableRow>
													<TableCell
														align="left"
														colSpan={2}
													>
														Nome
													</TableCell>
													<TableCell
														align="left"
													>
														Número
													</TableCell>
													<TableCell
														align="left"
													>
														Admin
													</TableCell>
													<TableCell
														align="left"
													>
														Ações
													</TableCell>
												</TableRow>
											</TableHead>
											<TableBody>
												{
													Array.isArray(groupInformation?.participants)
													&&
													groupInformation?.participants.map(p => {
														return (
															<TableRow>
																<TableCell align="left" style={{ width: "35px" }}>
																	<Avatar
																		style={{
																			width: "35px",
																			height: "35px",
																			boxShadow: "0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2)"
																		}}
																		src={p.profilePictureUrl}
																	/>
																</TableCell>
																<TableCell
																	align="left"
																	className={classNames({
																		[classes.removedUser]: removeUsers.includes(p.id)
																	})}
																>
																	{p.name}
																</TableCell>
																<TableCell
																	align="left"
																	className={classNames({
																		[classes.removedUser]: removeUsers.includes(p.id)
																	})}
																>
																	{p.number}
																</TableCell>
																<TableCell
																	align="left"
																	className={classNames({
																		[classes.removedUser]: removeUsers.includes(p.id)
																	})}
																>
																	{["admin", "superadmin"].includes(String(p?.admin).toLowerCase()) ? "Sim" : "Não"}
																</TableCell>
																<TableCell align="left">
																	<Tooltip
																		title={
																			<Typography component="label">Remover do Grupo</Typography>
																		}
																	>
																		<IconButton
																			aria-label="remove"
																			color="secondary"
																			disabled={p.number == numberConnection || groupInformation?.isAdmin != true || addUsers.includes(p.id)}
																			style={{ pointerEvents: "all" }}
																			onClick={() => handleRemoveUser(p.id)}
																			className={classNames({
																				[classes.disabled]: p.number == numberConnection || groupInformation?.isAdmin != true || addUsers.includes(p.id),
																			})}
																		>
																			<DeleteOutlineOutlinedIcon />
																		</IconButton>
																	</Tooltip>
																	<Tooltip
																		title={
																			<Typography component="label">Não Inserir no Grupo</Typography>
																		}
																	>
																		<IconButton
																			aria-label="cancel"
																			color="secondary"
																			disabled={addUsers.includes(p.id) == false}
																			style={{ pointerEvents: "all" }}
																			onClick={() => handleCancelUser(p.id)}
																			className={classNames({
																				[classes.disabled]: addUsers.includes(p.id) == false,
																			})}
																		>
																			<CancelOutlinedIcon />
																		</IconButton>
																	</Tooltip>
																</TableCell>
															</TableRow>
														)
													})
												}
											</TableBody>
										</Table>
									</TableContainer>
								</Grid>
							</Grid>
						</TabPanel>
					</>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => handleClose()}
						color="secondary"
						disabled={loading}
						variant="outlined"
					>
						{i18n.t("buttons.close")}
					</Button>

					<Button
						type="submit"
						color="primary"
						disabled={loading || (groupInformation?.canUpdateInformations != true && isCreate == false)}
						variant="contained"
						className={classes.btnWrapper}
						onClick={() => handleSave()}
					>
						{i18n.t("buttons.save")}
						{
							loading
							&&
							<CircularProgress
								size={24}
								className={classes.buttonProgress}
							/>
						}
					</Button>
				</DialogActions>
			</Dialog>
			<ConfirmationModal
				title="Sair do Grupo"
				open={leaveGroup}
				onClose={() => {
					setLeaveGroup(false);
				}}
				onConfirm={() => handleLeave()}
			>
				Você deseja realmente sair do grupo?
			</ConfirmationModal>
		</>
	);
};

export default GroupInformationModal;
